import { EKeyCode } from '@/enums/e_key_code';
import { use_slice_user } from '@/hooks/store/use_slices';
import { useToast } from '@/hooks/use-toast';
import i18n_base_ui from '@/locales/keys/i18n_base_ui.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { FN_USER_SETTINGS__update } from '@/utils/utils_client';
import { useTranslation } from 'react-i18next';
import { WATCHER_SHORTCUT__base } from './WATCHER_SHORTCUT__base';

export function WatcherShortcutShowShortcutsHints() {
  const { t } = useTranslation(ENUM__i18n_namespace.BASE_UI);

  const { user_settings } = use_slice_user(['user_settings']);

  const { toast } = useToast();

  /*
   * EVENTS
   */
  function on_shortcut_pressed() {
    let settings_new = user_settings.clone({ ui_hints_shortcuts_enabled: !user_settings.ui_hints_shortcuts_enabled });

    let title = t(
      settings_new.ui_hints_shortcuts_enabled ? i18n_base_ui.toasts.show_shortcut_hints.title_enabled : i18n_base_ui.toasts.show_shortcut_hints.title_disabled,
    );

    toast({ title });

    void FN_USER_SETTINGS__update(settings_new);

    return true;
  }

  /*
   * HTML
   */
  return <WATCHER_SHORTCUT__base key_codes={[EKeyCode.Slash]} {...{ on_shortcut_pressed }} />;
}
